import 'css-chunk:src/app/containers/TiktokSettings/components/TikTokTtoAccountsTable.scss';export default {
  "TableTitle": "_TableTitle_rha47_1",
  "RowTable": "_RowTable_rha47_5",
  "RemoveButton": "_RemoveButton_rha47_8",
  "loading": "_loading_rha47_14",
  "TikTokTtoAccountsTableFooter": "_TikTokTtoAccountsTableFooter_rha47_18"
};